<template>
    <div class="border-b border-[#eeeff2] mb-1.5 py-3">
        <span class="block text-[20px] font-[CircularBook] text-center">My Open Orders</span>
    </div>
    <div
        class="flex items-center"
        v-if="openOrdersLoading"
    >
        <Loading />
    </div>
    <div v-if="!openOrdersLoading">
        <div class="flex items-center px-5 pt-2.5 pb-2">
            <div class="relative w-full">
                <input
                    type="text"
                    id="orderSearch" class="bg-white border border-[#eeeff2] text-gray-900 text-sm rounded-[5px] focus:bg-white block w-full pe-10 p-2.5"
                    placeholder="Search"
                    v-model="searchOpenOrders"
                />
            </div>
        </div>
        <div class="relative overflow-x-auto table-wrapper mb-16">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 price-table whitespace-nowrap scrollable-table">
                <thead>
                <tr class="text-[#2a395a] text-[12px] font-[CircularBook] tracking-wider border-b border-[#eeeff2]">
                    <th scope="col" class="ps-5 pe-2 pb-2.5">
                        <button class="flex items-center w-full gap-2.5">
                            <span>Market</span>
                        </button>
                    </th>
                    <th scope="col" class="ps-5 pe-2 pb-2.5">
                        <button class="flex items-center w-full gap-2.5">
                            <span>Type</span>
                        </button>
                    </th>
                    <th scope="col" class="px-2 pb-2.5">
                        <button class="flex items-center justify-end w-full gap-2.5">
                            <span>Price</span>
                        </button>
                    </th>
                    <th scope="col" class="px-2 pb-2.5">
                        <button class="flex items-center justify-end w-full gap-2.5">
                            <span>Amount</span>
                        </button>
                    </th>
                    <th scope="col" class="ps-5 pe-2 pb-2.5">
                        <button class="flex items-center w-full gap-2.5">
                            <span>Filled</span>
                        </button>
                    </th>
                    <th scope="col" class="px-2 pb-2.5">
                        <button class="flex items-center justify-end w-full gap-2.5">
                            <span>Total</span>
                        </button>
                    </th>
                    <th scope="col" class="px-2 pb-2.5">
                        <button class="flex items-center justify-end w-full gap-2.5">
                            <span>Date</span>
                        </button>
                    </th>
                    <th scope="col" class="pe-5 px-2 pb-2.5">
                        <button class="flex items-center justify-end w-full gap-2.5">
                            <span>Actions</span>
                        </button>
                    </th>
                    <th scope="col" class="pe-5 px-2 pb-2.5">
                    </th>
                </tr>
                </thead>
                <tbody class="text-[12px] font-[CircularMedium] text-[#2a395a]">
                <tr
                    v-if="openOrders.length > 0"
                    class="bg-white text-right"
                    v-for="openOrder in openOrders"
                    :key="openOrder.id"
                >
                    <td class="ps-5 pe-2 py-[0] text-[#366fed] text-left">
                        {{ openOrder.market.title_formatted }}
                    </td>
                    <td class="ps-5 pe-2 py-[0] text-left">
                        {{ openOrder.direction }}
                    </td>
                    <td class="px-2 py-1">
                        {{ openOrder.price }} {{ openOrder.type === "SELL" ? openOrder.market.from_cgw_currency.slug : openOrder.market.to_cgw_currency.slug }}
                    </td>
                    <td class="px-2 py-1">
                        {{ openOrder.amount }} {{ openOrder.type === "SELL" ? openOrder.market.to_cgw_currency.slug : openOrder.market.from_cgw_currency.slug }}
                    </td>
                    <td class="px-2 py-1 text-center">
                        {{ openOrder.filled_percentage }}%
                    </td>
                    <td class="px-2 py-1">
                        {{ openOrder.total }} {{ openOrder.market.to_cgw_currency.slug }}
                    </td>
                    <td class="px-2 py-1">
                        {{ computedTimezoneDate(openOrder.created_at) }}
                    </td>
                    <td class="ps-2 pe-5 py-1">
                        <button
                            class="text-[#cf3d3d] text-[10px] border border-[#eeeff2] rounded-[2px] px-2.5 py-.5"
                            @click="cancelOrder(openOrder)"
                        >
                            CANCEL
                        </button>
                    </td>
                    <td class="px-2 py-1">
                        <a :href="`/exchange/query/order/${openOrder.id}`"><font-awesome-icon :icon="['fas', 'magnifying-glass']" /></a>
                    </td>
                </tr>
                <tr v-else>
                    <td colspan="7" class="!py-5">
                        <div class="flex items-center justify-center text-[#a4a6aa] text-[14px] font-[CircularMedium] tracking-wide gap-2">
                            <img src="@/../img/icons/file-gray.svg" alt="">
                            <span class="block">No data Available in table</span>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="border-b border-t border-[#eeeff2] mb-1.5 py-3">
        <span class="block text-[20px] font-[CircularBook] text-center">My Trading History</span>
    </div>
    <div
        class="flex items-center"
        v-if="tradingHistoryLoading"
    >
        <Loading />
    </div>
    <div v-if="!tradingHistoryLoading">
        <div class="flex items-center px-5 pt-2.5 pb-2">
            <div class="relative w-full">
                <input
                    type="text"
                    class="bg-white border border-[#eeeff2] text-gray-900 text-sm rounded-[5px] focus:bg-white block w-full pe-10 p-2.5"
                    placeholder="Search"
                    v-model="searchTradingHistory"
                />

            </div>
        </div>
        <div class="relative mb-16">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 price-table whitespace-nowrap mb-8">
                <thead>
                <tr class="text-[#2a395a] text-[12px] font-[CircularBook] tracking-wider border-b border-[#eeeff2]">
                    <th scope="col" class="ps-5 p3-2 pb-2.5">
                        <button class="flex items-center w-full gap-2.5">
                            <span>Market</span>
                        </button>
                    </th>
                    <th scope="col" class="px-2 pb-2.5">
                        <button class="flex items-center justify-end w-full gap-2.5">
                            <span>Type</span>
                        </button>
                    </th>
                    <th scope="col" class="px-2 pb-2.5">
                        <button class="flex items-center justify-end w-full gap-2.5">
                            <span>Price</span>
                        </button>
                    </th>
                    <th scope="col" class="px-2 pb-2.5">
                        <button class="flex items-center justify-end w-full gap-2.5">
                            <span>Amount</span>
                        </button>
                    </th>
                    <th scope="col" class="px-2 pb-2.5">
                        <button class="flex items-center justify-end w-full gap-2.5">
                            <span>Fee</span>
                        </button>
                    </th>
                    <th scope="col" class="px-2 pb-2.5">
                        <button class="flex items-center justify-end w-full gap-2.5">
                            <span>Total</span>
                        </button>
                    </th>
                    <th scope="col" class="ps-2 pe-5 pb-2.5">
                        <button class="flex items-center justify-end w-full gap-2.5">
                            <span>Date</span>
                        </button>
                    </th>
                    <th scope="col" class="ps-2 pe-5 pb-2.5"></th>
                </tr>
                </thead>
                <tbody class="text-[12px] font-[CircularMedium] text-[#2a395a]">
                <tr
                    v-if="tradingHistory.length > 0"
                    class="bg-white text-right"
                    v-for="trade in tradingHistory"
                    :key="trade.id"
                >
                    <td class="ps-5 pe-2 py-[0] text-[#366fed] text-left">
                        {{ trade.market.title_formatted }}
                    </td>
                    <td class="px-2 py-1">
                        {{ trade.role }}
                    </td>
                    <td class="px-2 py-1">
                        {{ trade.price }} {{ trade.price_currency }}
                    </td>
                    <td class="px-2 py-1">
                        {{ trade.executed }} {{ trade.executed_currency }}
                    </td>
                    <td class="px-2 py-1">
                        {{ trade.fee }} {{ trade.fee_currency }}
                    </td>
                    <td class="px-2 py-1">
                        {{ trade.total }} {{ trade.to_currency }}
                    </td>
                    <td class="ps-2 pe-5 py-1">
                        {{ computedTimezoneDate(trade.created_at) }}
                    </td>
                    <td class="px-2 py-1">
                        <a :href="`/exchange/query/order/${trade.order_id}`"><font-awesome-icon :icon="['fas', 'magnifying-glass']" /></a>
                    </td>
                </tr>
                <tr v-else>
                    <td colspan="7" class="!py-5">
                        <div class="flex items-center justify-center text-[#a4a6aa] text-[14px] font-[CircularMedium] tracking-wide gap-2">
                            <img src="@/../img/icons/coin-trade-gray.svg" alt="">
                            <span class="block">You have no trading history</span>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <div
                v-if="tradingHistoryLinks.length > 0"
                class="flex items-center justify-center gap-[5px] text-[#2a395a] text-[14px] font-[CircularBook]"
            >
                <button
                    v-for="(page) in tradingHistoryLinks"
                    class="bg-[#f3f4f9] border border-transparent rounded-[5px] px-2.5 py-1 tracking-wide h-[34px] min-w-[34px] hover:border hover:border-[#366fed] hover:bg-[#e0e8fa] hover:text-[#366fed]"
                    :class="page.active ? '!border-[#366fed] bg-[#e0e8fa] text-[#366fed]' : ''"
                    :disabled="page.url === null"
                    @click="fetchTradingHistory(page.url)"
                    v-html="page.label"
                >
                </button>
            </div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref, watch } from 'vue'
import {globalStore} from "../stores"
import {backendSocket} from "../sockets"
import axios from "axios"
import Swal from "sweetalert2"
import {debounce} from "lodash"
import moment from "moment";
import Loading from "../components/Loading.vue";

const openOrders = ref([])
const openOrdersLoading = ref(true);
const tradingHistory = ref({})
const tradingHistoryLoading = ref(true);
const tradingHistoryLinks = ref([])
const searchOpenOrders = ref("")
const searchTradingHistory = ref("")

const computedTimezoneDate = (date) => {
    return moment(date).format("YYYY-MM-DD HH:mm:ss")
}

watch(searchTradingHistory, debounce(() => {
    fetchTradingHistory(null, searchTradingHistory.value)
}, 500))

watch(searchOpenOrders, debounce(() => {
    fetchOpenOrders(searchOpenOrders.value)
}, 500))

onMounted(() => {
    if (globalStore.userId) {
        fetchOpenOrders()
        fetchTradingHistory()
    }

    if (globalStore.userId) {
        backendSocket.private(`exchange.${globalStore.userId}`)
            .listen('.order.updated', ({order}) => {
                const index = openOrders.value.map(e => e.id).indexOf(order.id)
                switch (order.status) {
                    case 'PLACED':
                        openOrders.value.unshift(order)
                        break
                    case 'FILLED':
                        if (index > -1) openOrders.value.splice(index, 1)
                        break;
                    case 'PARTIALLY_FILLED':
                        if (index > -1) openOrders.value[index] = order
                        break;
                }
            }).listen('.trade.created', ({trade}) => {
                const index = tradingHistory.value.map(e => e.id).indexOf(trade.id)
                if (index > -1) {
                    tradingHistory.value[index] = trade
                } else {
                    tradingHistory.value.unshift(trade)
                }
            }
        )
    }
})

const cancelOrder = (order) => {
    axios.post("/exchange/query/cancel-order", {order_id: order.id})
        .then(({ data: { data } }) => {
            const index = openOrders.value.map(e => e.id).indexOf(order.id)
            if (index > -1) openOrders.value.splice(index, 1)
        })
        .catch(({ response: {data} }) => {
            Swal.fire('Warning!', data.data.message, 'warning')
        });
}

const fetchOpenOrders = (query = null) => {
    axios
        .get(query ? "/exchange/query/open-orders" + "?query=" + query : "/exchange/query/open-orders")
        .then(({ data: { data } }) => {
            openOrders.value = data
            openOrdersLoading.value = false
        })
}

const fetchTradingHistory = (link = null, query = null) => {
    axios.get(link || (query ? "/exchange/query/trading-history" + "?query=" + query : "/exchange/query/trading-history"))
        .then(({ data: { data } }) => {
            tradingHistory.value = data.tradingHistory.data
            tradingHistoryLoading.value = false
            tradingHistoryLinks.value = data.tradingHistory.links;
        })
}
</script>
